/**
 * Helper: Product
 * -----------------------------------------------------------------------------
 * Cross-component product-specific helper functions.
 * - Add in alphabetical order.
 *
 */

/**
 * Return if the current variant is digital.
 * @param {Boolean|Object} - Variant object.
 * @returns {Boolean}
 */
export function isDigitalVariant(variant) {
  if (!variant) {
    return false
  }

  return variant?.selectedOptions.some((option) => {
    return window.cnvs.settings.productOptions.digital
      .includes(option.value)
  })
}
